import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  FieldConfig,
  FieldDataTypes,
  HasUidInterface,
  NameableInterface,
  nString,
  uNumber,
  Uuid,
} from '@hidat/huijs-common';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import {
  BrandedResource,
  ExtendedBrandingInterface,
} from './branded-resource.interface';
import { HashViews } from './hash-views';

export const HostConfig: ResourceConfig = new ResourceConfig('Host')
  .addFields(splixerSystemFields)
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.name.setRequired(true),
      splixerFieldConfigs.tagLine,
      splixerFieldConfigs.description,
      splixerFieldConfigs.imageUrl,
      new FieldConfig('branding', FieldDataTypes.HASH),
      new FieldConfig('priority', FieldDataTypes.INTEGER),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.intId,
    splixerFieldConfigs.status,
    new FieldConfig('airName'),
    new FieldConfig('duration', FieldDataTypes.INTEGER).setEditable(false),
    splixerFieldConfigs['stationId'],
    splixerFieldConfigs['remoteId'],
    splixerFieldConfigs['remoteCode'],
    ...splixerSystemFields,
  ])
  .setSorts({
    name: 'name',
  })
  .setDefaultSort('name');

export const PlayerHostIncludes = {
  shows: 'shows',
  mixes: 'mixes',
  default_mix: 'default_mix',
};

export const HostFilterConfig = new SearchFilterConfig(HostConfig, {
  only: ['name', 'status']
})

export interface PlayerHostInterface
  extends
    SplixerResourceInterface<number>,
    NameableInterface,
    BrandedResource<number>,
    HasUidInterface {
  uid: Uuid | undefined;
  tagLine: nString;
  description: nString;
  branding: ExtendedBrandingInterface | undefined;
  priority: uNumber;
  airName: string | undefined;
  imageUrl: string | undefined;
}

export interface HostInterface extends PlayerHostInterface {
  duration: number | undefined;
  invalidSegments: number | undefined;
  stationId: number | undefined;
  remoteCode: string | undefined | null;
  remoteId: number | undefined | null;
  tenantId: Uuid | undefined;
  defaultMixId: number | undefined;
}

export interface HostFilter {
  minPriority?: number;
}
